/**
 * Validate the fields with empty or undefined state
 * @author: SAR TECH EASY
 * Date:19-01-2023
 */
const isNotNull = function (data) {
  if (
    data !== null &&
    data !== undefined &&
    data !== 'null' &&
    data !== 'undefined' &&
    data !== ''
  ) {
    return true;
  } else {
    return false;
  }
};

//Validate Success response
const isSuccessResponse = function (status) {
  if (isNotNull(status) && status === 200) {
    return true;
  } else {
    return false;
  }
};

//validate array empty
const isArrayNotEmpty = function (arr) {
  if (isNotNull(arr) && arr.length > 0) {
    return true;
  } else {
    return false;
  }
};

const roundToTwoDecimals = function (num) {
  const precision = 100;
  const thirdDecimal = Math.floor((num * precision * 10) % 10);
  if (thirdDecimal > 0) {
    const roundedNum = Math.ceil(num * precision) / precision;
    if (isNaN(roundedNum)) {
      return 0;
    }
    return Number(roundedNum);
  } else {
    return Number(num.toFixed(2));
  }
};

// Default export containing all validator functions
const Validators = {
  isNotNull: isNotNull,
  isSuccessResponse: isSuccessResponse,
  isArrayNotEmpty: isArrayNotEmpty,
  roundToTwoDecimals: roundToTwoDecimals,
};

export default Validators;

// Named exports for individual functions
export {
  isNotNull,
  isSuccessResponse,
  isArrayNotEmpty,
  roundToTwoDecimals,
};
